import{instancesData}from"../../subclass/map.js";

import{getAnyErrorInfo,getKnownErrorInfo,getSubclasses}from"./error.js";



export const getErrorPluginInfo=({error,methodOpts,plugins,plugin})=>{
const{ErrorClass,options}=getKnownErrorInfo({
error,
methodOpts,
plugins,
plugin
});
const info=getPluginInfo({
options,
ErrorClass,
methodOpts,
plugins,
plugin
});

Object.assign(info,{error});
return info
};


export const getPluginInfo=({
options,
ErrorClass,
methodOpts,
plugins,
plugin
})=>{
const errorInfo=getAnyErrorInfo.bind(undefined,{
ErrorClass,
methodOpts,
plugins,
plugin
});
const ErrorClasses=getSubclasses(ErrorClass);
const info={options,ErrorClass,ErrorClasses,errorInfo};
setInstancesData(info);
return info
};



const setInstancesData=(info)=>{

Object.defineProperty(info,"instancesData",{
value:instancesData,
enumerable:false,
writable:true,
configurable:true
})
};